import React, { Component } from 'react'
import SetupPV from './SetupPV'
import AuthA from '../../store/actions/AuthA'

import {connect} from 'react-redux'

class SetupPC extends Component {
  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup'});
  }

  render() {
    return (
      <SetupPV auth={this.props.auth} userType={this.props.userType}/>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetupPC);
